<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { LANDING_PAGE } from '@/types'
import RenewAuthorisationDeclarationForm from '@/components/dashboard/authorisation/RenewAuthorisationDeclarationForm.vue'

const store = useStore()
const router = useRouter()

const onSuccess = () => {
  store.commit('SET_LANDING_PAGE', LANDING_PAGE.DASHBOARD)
  router.push({ name: 'Account' }).catch(() => {})
}
</script>

<template>
  <section class="sa-acct-section" aria-labelledby="renew-declaration-heading">
    <h2 id="renew-declaration-heading">
      {{ $t('Dashboard.Status.Authorisation.Title') }}
    </h2>
    <p class="sa-renew-flow__lead">
      {{ $t('Dashboard.Settings.RenewAuth.DeclarationLead') }}
    </p>

    <RenewAuthorisationDeclarationForm @success="onSuccess" />
  </section>
</template>
